import React from "react";
import { StyledSVG } from "../styled";
import { sizes } from "../options";

const Close = ({ variant, size, className }) => {
  return (
    <StyledSVG
      variant={variant}
      className={className}
      size={size}
      viewBox={`0 0 ${sizes[size].width.split("p")[0]} ${sizes[size].height.split("p")[0]}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M20.5303 4.53025C20.8232 4.23736 20.8232 3.76249 20.5303 3.46959C20.2374 3.1767 19.7625 3.1767 19.4696 3.46959L12 10.9392L4.53033 3.46959C4.23743 3.1767 3.76256 3.1767 3.46967 3.46959C3.17677 3.76249 3.17677 4.23736 3.46967 4.53025L10.9393 11.9999L3.46961 19.4696C3.17672 19.7625 3.17672 20.2374 3.46961 20.5303C3.7625 20.8231 4.23738 20.8231 4.53027 20.5303L12 13.0606L19.4697 20.5303C19.7626 20.8231 20.2374 20.8231 20.5303 20.5303C20.8232 20.2374 20.8232 19.7625 20.5303 19.4696L13.0606 11.9999L20.5303 4.53025Z"/>
    </StyledSVG>
  )
}

export default Close;
